// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"785":"a7f0a496","787":"6d35470b"}[chunkId] + ".chunk.js";
};